import { Form } from "antd";
import { useMemo } from "react";
import ModalStyled from "./styled";
import { SelectedItem, ShiftManagement, ShiftType } from "../../type";
import RenderDateForm from "./RenderDateForm";

interface IProps {
  open: boolean;
  onCancel: () => void;
  selectedItems: SelectedItem[];
  handleSaveTmpDataSubmit: (
    data: {
      dateFormats: string[];
      nurseId: string;
      shiftType: ShiftType;
      isDelete: boolean;
      note?: string | null;
    }[]
  ) => void;
  isStaff: boolean;
  nameNurseSelecting: string;
  listShiftManagement?: ShiftManagement[]
}

const MolalSchedule = (props: IProps) => {
  const {
    open,
    onCancel,
    selectedItems,
    handleSaveTmpDataSubmit,
    nameNurseSelecting,
    listShiftManagement,
  } = props;
  const [form] = Form.useForm();
  const handleSubmit = () => {
    const values = form.getFieldsValue();

    const data = Object.entries(values).map(([nurseId, nurseData]: [string, any]) => {
      const dateFormats = Object.values(
        (nurseData.dates ?? {}) as Record<string, string>
      ).filter(Boolean) as string[];
      return {
        nurseId,
        dateFormats,
        shiftType: nurseData.shift_type as ShiftType,
        isDelete: nurseData.isDelete || false,
        note: nurseData.note || null,
      };
    });

    handleSaveTmpDataSubmit(data);
    form.resetFields();
    onCancel();
  };

  const groupByNurse = (data: SelectedItem[]) => {
    return data.reduce<Record<string, SelectedItem[]>>((acc, item) => {
      
      if (!acc[item.indexRow]) {
        acc[item.indexRow] = [];
      }

      acc[item.indexRow].push(item);

      return acc;
    }, {});
  };

  const selectedItemsGroupByNurse = useMemo(
    () => groupByNurse(selectedItems),
    [selectedItems]
  );

  return (
    <ModalStyled
      open={open}
      okText="保存"
      title={
        <div>
          <div className="text-sm text-[#010A02] !pr-1">休日・出勤調整</div>
         
        </div>
      }
      okButtonProps={{ className: "w-[60px] h-9 mr-2" }}
      className="!w-[389px]"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => form.submit()}
      centered
    >
      {open && (
        <Form
          layout={"vertical"}
          form={form}
          onFinish={handleSubmit}
          labelWrap
          className="max-h-[calc(100vh-150px)] overflow-y-auto pr-2"
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
          }}
        >
          <div className="flex flex-col gap-4 mb-4">
            {Object.values(selectedItemsGroupByNurse).map((x) => {
              const nurseId = x[0]?.nurseId
                const familyName = listShiftManagement?.find(x => x.id === Number(nurseId))?.family_name
                return <div key={nurseId}>
                <RenderDateForm selectedItems={x} familyName={familyName || ""} />
              </div>
              }
            )}
          </div>
        </Form>
      )}
    </ModalStyled>
  );
};

export default MolalSchedule;
